import { HTTPStatusCode } from "@libs/api/types";
import { UpdateCurrentPatientType } from "@/domain/patients";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";
import { logger } from "@/utils/logger";

export const PatientsApi = {
  getCurrentPatient: async () => {
    const res = await tsRestClient().patients.getCurrentPatient();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to get current patient",
      shouldThrowError: true,
    });
  },
  updateCurrentPatient: async (params: UpdateCurrentPatientType) => {
    const res = await tsRestClient().patients.updateCurrentPatient({
      body: params,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Failed to update current patient",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
